import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import PaperCard from '../components/PaperCard';
import Loading from '../components/Loading';
import ErrorMessage from '../components/ErrorMessage';
import { API_V1, apiGet } from '../lib/api';

const API = `${API_V1}/digests`;

export default function SearchPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const q = searchParams.get('q') || '';
  const [inputVal, setInputVal] = useState(q);
  const [papers, setPapers] = useState([]);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');

  useEffect(() => {
    setInputVal(q);
    if (!q.trim()) {
      setPapers([]);
      setCount(0);
      return;
    }
    setLoading(true);
    setPapers([]);
    apiGet(`${API}/articles/search?q=${encodeURIComponent(q)}`)
      .then(d => {
        setPapers(d.results);
        setCount(d.count);
      })
      .catch(e => setErr(e.message))
      .finally(() => setLoading(false));
  }, [q]);

  const submit = (e) => {
    e.preventDefault();
    const v = inputVal.trim();
    if (v) setSearchParams({ q: v });
  };

  const clear = () => {
    setInputVal('');
    if (q) setSearchParams({});
  };

  if (err) return <ErrorMessage message={err} />;

  return (
    <div className="page-search">
      <form className="search-bar" onSubmit={submit}>
        <i className="fas fa-search" />
        <input
          className="search-input"
          value={inputVal}
          onChange={(e) => setInputVal(e.target.value)}
          placeholder="搜索论文解读：标题 / 中文摘要 / arxiv id..."
          autoFocus
        />
        {inputVal && (
          <button type="button" className="search-clear" onClick={clear} title="清空搜索词">
            <i className="fas fa-times" />
          </button>
        )}
      </form>

      {!q.trim() ? (
        <div className="empty-hint">输入关键词搜索站内论文解读（标题权重最高，中文摘要次之）</div>
      ) : loading ? (
        <Loading />
      ) : (
        <>
          <div className="content-head">
            <h2>“{q}” 的搜索结果</h2>
            <span className="content-sub">{count} 篇命中</span>
          </div>
          {papers.length === 0 ? (
            <div className="empty-hint">没有匹配的解读，换个关键词试试</div>
          ) : (
            <div className="card-grid">
              {papers.map(p => <PaperCard key={p.id} paper={p} highlight={q} navIds={papers.map(x => x.id)} />)}
            </div>
          )}
        </>
      )}
    </div>
  );
}
